import {
  createStore, applyMiddleware, compose, combineReducers,
} from 'redux';
import { connectRoutes } from 'redux-first-router';
import queryString from 'query-string';

import routesMap from './routesMap';
import * as reducers from './reducers';

export default (preloadedState, initialEntries) => {
  const {
    reducer, middleware, enhancer, thunk,
  } = connectRoutes(routesMap, {
    querySerializer: queryString,
    initialEntries,
  });

  const rootReducer = combineReducers({ ...reducers, location: reducer });
  const middlewares = applyMiddleware(middleware);
  const enhancers = compose(enhancer, middlewares);
  const store = createStore(rootReducer, preloadedState, enhancers);

  if (module.hot && process.env.NODE_ENV !== 'production') {
    module.hot.accept('./reducers/index', () => {
      store.replaceReducer(rootReducer);
    });
  }

  return { store, thunk };
};
